import PropTypes from "prop-types";

const propTypes = {
  priorita: PropTypes.shape({
    I_PRIORITA: PropTypes.number,
    N_PRIORITA: PropTypes.string,
  }),
};

export default propTypes;
